import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import Button from "./../../Common/Button";

export default class SortedListPagination extends PureComponent {
  static propTypes = {
    onNextPageClick: PropTypes.func.isRequired,
    onPreviousPageClick: PropTypes.func.isRequired,
    currentPage: PropTypes.number,
    dataCount: PropTypes.number,
    firstElement: PropTypes.number,
    lastElement: PropTypes.number
  };

  static defaultProps = {
    currentPage: 1,
    dataCount: 0
  };

  handlePreviousPageClick = () => this.props.onPreviousPageClick();

  handleNextPageClick = () => this.props.onNextPageClick(this.props.dataCount);

  render() {
    const { currentPage, dataCount, firstElement } = this.props;
    const lastElement = this.props.lastElement > dataCount ? dataCount : this.props.lastElement;
    const hasOneItem = firstElement + 1 === lastElement;
    const elementsLabel = !hasOneItem ? `${firstElement + 1}-${lastElement}` : lastElement;

    return (
      <div role="navigation" className="pagination">
        <span>
          {elementsLabel} {i18n.t("pagination.of")} {dataCount}
        </span>
        <Button
          className={classNames("pagination__arrow", currentPage === 1 && "--inactive")}
          icon="arrow-left"
          onClick={this.handlePreviousPageClick}
        />
        <Button
          className={classNames("pagination__arrow", lastElement >= dataCount && "--inactive")}
          icon="arrow-right"
          onClick={this.handleNextPageClick}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/SortedListPagination.js